import { ReservationState } from './model.roomsAndTotals';
export function subscribeDates(reservationState: ReservationState) {
    reservationState.unsubscribeDates();
    const subscriptions = [
        ...reservationState.RoomBookings.toArray().map(roomBooking => ([
            ...(roomBooking.Dates.map(d => ([
                d.RatePlanOverride.subscribe(() => reservationState.checkPrices()),
                d.BaseRateOverride.subscribe(() => reservationState.checkPrices()),
                d.RecalculateStayPeriod.subscribe(() => reservationState.checkPrices()),
                d.UseOriginalRatePlan.subscribe(() => reservationState.checkPrices()),
                d.MinorAdjustment.subscribe(() => reservationState.checkPrices()),
                d.AppliedVouchers.subscribe(() => reservationState.checkPrices()),
                d.OpenPrice.subscribe(() => reservationState.checkPrices()),
                d.OpenPriceDescription.subscribe(() => reservationState.checkPrices()),
                d.IgnoreVouchers.subscribe(() => reservationState.checkPrices())
            ]))),
            roomBooking.RatePlanOverride.subscribe(() => reservationState.checkPrices()),
            roomBooking.BaseRateOverride.subscribe(() => reservationState.checkPrices()),
            roomBooking.RecalculateStayPeriod.subscribe(() => reservationState.checkPrices()),
            roomBooking.UseOriginalRatePlan.subscribe(() => reservationState.checkPrices()),
            roomBooking.AppliedVouchers.subscribe(() => reservationState.checkPrices()),
            roomBooking.LockRate.subscribe(() => reservationState.checkPrices()),
            roomBooking.Recalculate.subscribe(() => reservationState.checkPrices()),
            roomBooking.OpenPrice.subscribe(() => reservationState.checkPrices()),
            roomBooking.OpenPriceDescription.subscribe(() => reservationState.checkPrices()),
            roomBooking.IgnoreVouchers.subscribe(() => reservationState.checkPrices()),
        ].flat())).flat(),
        ...reservationState.ProgramBookings.toArray().map(programBooking => ([
            ...(programBooking.Dates.map(d => ([
                d.RatePlanOverride.subscribe(() => reservationState.checkPrices()),
                d.BaseRateOverride.subscribe(() => reservationState.checkPrices()),
                d.RecalculateStayPeriod.subscribe(() => reservationState.checkPrices()),
                d.UseOriginalRatePlan.subscribe(() => reservationState.checkPrices()),
                d.MinorAdjustment.subscribe(() => reservationState.checkPrices()),
                d.AppliedVouchers.subscribe(() => reservationState.checkPrices()),
                d.OpenPrice.subscribe(() => reservationState.checkPrices()),
                d.OpenPriceDescription.subscribe(() => reservationState.checkPrices()),
                d.IgnoreVouchers.subscribe(() => reservationState.checkPrices())
            ]))),
            programBooking.RatePlanOverride.subscribe(() => reservationState.checkPrices()),
            programBooking.BaseRateOverride.subscribe(() => reservationState.checkPrices()),
            programBooking.RecalculateStayPeriod.subscribe(() => reservationState.checkPrices()),
            programBooking.UseOriginalRatePlan.subscribe(() => reservationState.checkPrices()),
            programBooking.AppliedVouchers.subscribe(() => reservationState.checkPrices()),
            programBooking.LockRate.subscribe(() => reservationState.checkPrices()),
            programBooking.Recalculate.subscribe(() => reservationState.checkPrices()),
            programBooking.StartHalfDay.subscribe(() => reservationState.checkPrices()),
            programBooking.EndHalfDay.subscribe(() => reservationState.checkPrices()),
        ].flat())).flat()
    ];
    reservationState.unsubscribeDates = () => {
        subscriptions.forEach(s => s());
    };
}

export interface DiffTransaction {
    Description: string;
    Amount: number;
}

export interface RatePlanKey {
    RatePlanId: string;
    RatePlanVersion: number;
}
